import type { SVGProps } from "react";
const Svg25PercentSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={33}
    height={33}
    fill="none"
    {...props}
  >
    <g clipPath="url(#25_Percent_SVG_svg__a)">
      <path fill="#CFD7E4" stroke="#103976" d="M4.5-8.5h24v19h-24z" />
      <path fill="#D2D2D2" fillOpacity={0.84} d="M4-9h25v36H4z" />
      <path stroke="#103976" d="M5 10.5h23" />
      <path fill="#CFD7E4" stroke="#103976" d="M4.5 10.5h24v16h-24z" />
      <circle cx={16.5} cy={8.5} r={6.5} fill="#D2D2D2" />
      <circle cx={16.5} cy={8.5} r={6} stroke="#ADAFB0" strokeOpacity={0.5} />
    </g>
    <defs>
      <clipPath id="25_Percent_SVG_svg__a">
        <path fill="#fff" d="M0 0h33v33H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default Svg25PercentSvg;
